import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { Button, Tooltip } from 'antd';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  DownloadOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { useDiagnostics } from './DiagnosticsContext';
import { buildCategories } from './services/categories';
import { downloadReport } from './services/ReportExporter';
import { DIAGNOSTICS_PORTS } from './config/endpoints';
import DiagnosticDetails from './DiagnosticDetails';

const NetworkTestCard = ({ title }) => {
  const { report, isRunning, runTest } = useDiagnostics();
  const [detailsOpen, setDetailsOpen] = useState(false);
  const hasRun = Boolean(report.reportId);
  const categories = useMemo(() => buildCategories(report, DIAGNOSTICS_PORTS), [report]);

  return (
    <>
      <div className="help-page-card-header">{title}</div>
      <div className="diagnostics-card-body">
        <p className="diagnostics-card-text">
          Check whether the network you are on can support HomeSight video calling and live
          notifications.
        </p>

        <div className="diagnostics-actions-row">
          <Button
            type="primary"
            size="large"
            loading={isRunning}
            onClick={runTest}
            className="diagnostics-run-btn"
          >
            Run Network Test
          </Button>
          <Tooltip title="Diagnostic details">
            <Button
              shape="circle"
              icon={<InfoCircleOutlined />}
              disabled={!hasRun}
              onClick={() => setDetailsOpen(true)}
            />
          </Tooltip>
          <Tooltip title="Download JSON">
            <Button
              shape="circle"
              icon={<DownloadOutlined />}
              disabled={!hasRun}
              onClick={() => downloadReport(report)}
            />
          </Tooltip>
        </div>

        {hasRun && (
          <ul className="diagnostics-summary-list">
            {categories.map((category) => (
              <li key={category.key} className="diagnostics-summary-row">
                <span className="diagnostics-summary-label">
                  {category.status === 'pass' ? (
                    <CheckCircleFilled className="diagnostics-icon-pass" />
                  ) : (
                    <CloseCircleFilled className="diagnostics-icon-fail" />
                  )}
                  {category.title}
                </span>
                <span
                  className={
                    category.status === 'pass'
                      ? 'diagnostics-result-pass'
                      : 'diagnostics-result-fail'
                  }
                >
                  {category.status === 'pass' ? 'PASS' : 'FAIL'}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <DiagnosticDetails
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        categories={categories}
      />
    </>
  );
};

NetworkTestCard.propTypes = {
  title: PropTypes.string,
};

NetworkTestCard.defaultProps = {
  title: 'Network Diagnostics',
};

export default NetworkTestCard;
